/* eslint-disable no-undef */
export const fqa = fqaInit || {} 
export const cartJson = cartJsonInit || "" 
export const themeName = themeNameInit || "" 

// eslint-disable-next-line prefer-const
// eslint-disable-next-line no-var
export var firstTimeUrl = firstTimeUrlInit || "" // eslint-disable-line import/no-mutable-exports